'use strict';

var CustomFieldsDetailCtrl = function ($stateParams,
                                       $state,
                                       $scope,
                                       Notification,
                                       office,
                                       OfficeDA,
                                       type,
                                       gettextCatalog) {
    this.Notification = Notification;
    this.OfficeDA = OfficeDA;
    this.office = office;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.type = type;
    this.gettextCatalog = gettextCatalog;
    this.showPremiumNotification = $scope.subscription.empty === undefined && !['plus', 'enterprise'].includes($scope.subscription.package);
    this.form = null;
    this.formSubmitted = false;
    this.services = [];
    this.groups = [];
    this.customFields = [];
    this.fieldName = this.$stateParams.name;
    this.optionTranslation_ = gettextCatalog.getString('Select');

    this.conditionTypes = [
        {
            name: 'service',
            label: gettextCatalog.getString('Service')
        },
        {
            name: 'serviceGroup',
            label: gettextCatalog.getString('Service Group')
        },
        {
            name: 'customField',
            label: gettextCatalog.getString('Custom Field')
        }
    ];

    this.fieldTypes = [
        {
            name: gettextCatalog.getString('Textfield'),
            type: 'textfield'
        },
        {
            name: gettextCatalog.getString('Textarea'),
            type: 'textarea'
        },
        {
            name: gettextCatalog.getString('Select'),
            type: 'select'
        },
        {
            name: gettextCatalog.getString('Radio'),
            type: 'radio'
        }
    ];
    this.customFieldMap = {};


    office.serviceGroups.forEach((serviceGroup) => {
        this.groups.push({
            _id: serviceGroup._id,
            name: serviceGroup.name
        });

        serviceGroup.services.forEach((service) => {
            this.services.push({
                name: service.name,
                _id: service._id,
                group: serviceGroup.name
            });
        });
    });

    // TODO: premium notification
    ['customer', 'appointment'].forEach((customFieldType) => {
        if (office.settings.customFields[customFieldType]) {
            office.settings.customFields[customFieldType].forEach((customField) => {
                if (customField.name !== this.fieldName) {
                    this.customFields.push({
                        label: customField.label,
                        name: customField.name,
                        fieldType: customFieldType
                    });
                }

                this.customFieldMap[customField.name] = {
                    ...customField,
                    fieldType: customFieldType
                };
            });

        }
    });

    const existingCustomField = this.customFieldMap[$stateParams.name];

    this.model = {};

    if ($stateParams.name === 'new' || !existingCustomField) {
        this.model = {
            label: gettextCatalog.getString('New field'),
            required: true,
            booking: true,
            conditionsGroups: [],
            type: 'textfield'
        };
    } else {
        this.model = existingCustomField;
    }
};

/**
 * fired if field type selectbox has changed
 */
CustomFieldsDetailCtrl.prototype.changeTypeHandler = function () {
    var multiOptionFields = {
        radio: true,
        select: true
    };

    if (multiOptionFields[this.model.type]) {
        this.model.options = this.model.options || [];

        if (this.model.options.length === 0) {
            this.model.options.push({
                label: this.optionTranslation_ + ' 1'
            });

            this.model.options.push({
                label: this.optionTranslation_ + ' 2'
            });
        }

    } else {
        this.model.options = null;
    }
};


/**
 * @param {object} option
 */
CustomFieldsDetailCtrl.prototype.removeOption = function (option) {
    var index = this.model.options.indexOf(option);

    if (this.model.options.length > 2) {
        this.model.options.splice(index, 1);
    }
};


/**
 * add an option to radio option list
 */
CustomFieldsDetailCtrl.prototype.addOption = function () {
    this.model.options.push({
        label: this.optionTranslation_
    });
};


CustomFieldsDetailCtrl.prototype.addConditionGroup = function () {
    this.model.conditionsGroups = this.model.conditionsGroups || [];

    this.model.conditionsGroups.push({
        conditions: [
            {
                type: 'service'
            }
        ]
    });
};

CustomFieldsDetailCtrl.prototype.addCondition = function (conditionGroup) {
    conditionGroup.conditions.push({
        type: 'service',
        check: 'equal',
        field: '',
        value: '',
    });
};

CustomFieldsDetailCtrl.prototype.removeConditionGroup = function (index) {
    this.model.conditionsGroups.splice(index, 1);
};

CustomFieldsDetailCtrl.prototype.removeCondition = function (conditionsGroup, index) {
    conditionsGroup.conditions.splice(index, 1);
};

CustomFieldsDetailCtrl.prototype.save = function () {
    const self = this;

    this.formSubmitted = true;

    if (!this.form.$valid) {
        return;
    }

    if (this.$stateParams.name === 'new') {
        this.office.settings.customFields[this.type].push(this.model);
    } else {
        const customFieldIndex = this.office.settings.customFields[this.type].findIndex((customField) => customField.name === this.$stateParams.name);

        if (customFieldIndex > -1) {
            this.office.settings.customFields[this.type][customFieldIndex] = this.model;
        }
    }

    this.OfficeDA
        .update(this.office)
        .then(() => {
            self.Notification.addSuccessMessage(self.gettextCatalog.getString('Custom field saved'));
            self.$state.go('private.main.customFields');
        })
        .catch(() => {
            self.Notification.addErrorMessage(self.gettextCatalog.getString('Cant save custom field'));
        });
};

CustomFieldsDetailCtrl.prototype.delete = function () {
    const self = this;

    if (this.$stateParams.name === 'new') {
        self.Notification.addSuccessMessage(self.gettextCatalog.getString('Custom field removed'));
        self.$state.go('private.main.customFields');
    } else {
        const customFieldIndex = this.office.settings.customFields[this.type].findIndex((customField) => customField.name === this.$stateParams.name);

        if (customFieldIndex > -1) {
            this.office.settings.customFields[this.type].splice(customFieldIndex, 1);
            this.OfficeDA
                .update(this.office)
                .then(() => {
                    self.Notification.addSuccessMessage(self.gettextCatalog.getString('Custom field removed'));
                    self.$state.go('private.main.customFields');
                })
                .catch(() => {
                    self.Notification.addSuccessMessage(self.gettextCatalog.getString('Cannot remove Custom field'));
                });
        }
    }
};

CustomFieldsDetailCtrl.prototype.back = function () {
    this.$state.go('private.main.customFields');
};

CustomFieldsDetailCtrl.prototype.conditionTypeChanged = function (condition) {
    condition.value = '';
    condition.field = '';
    condition.check = 'equal';
};

CustomFieldsDetailCtrl.prototype.conditionCFChanged = function (condition) {
    condition.value = '';
    condition.check = 'equal';

    if (this.customFieldMap[condition?.field]) {
        condition.fieldType = this.customFieldMap[condition?.field].fieldType;
    }
};

module.exports = CustomFieldsDetailCtrl;
